let alertConfirm = {
	//默认弹出框，包含确定和取消
	//@Params message 弹出框信息
	//@Params callback 弹出框回调函数
	alertConfirm: function(message,callback){		
		this.confirm("normal",message,callback);
	},
	//单击弹出框，只包含确定
	//@Params message 弹出框信息
	//@Params callback 弹出框回调函数
	singleConfirm: function(message,callback){
		this.confirm("single",message,callback);
	},
	//弹出框本体函数
	//@Params type 弹出框类型
	//@Params message 弹出框信息
	//@Params callback 弹出框回调函数
	confirm: function(type,message,callback){
		var that = this;
		
		if(!window.document.getElementById("alertConfirm")){
        	this.init(type);
        }
		
		if(!callback){
			callback = function(){};
		}
		
        $('#alertM').html(message);
        
        if(type == "normal"){
        	$('#cancle').on('click',function(){
        	$('.cd-popup').removeClass('is-visible');
        })
        }
        
        $('#close').on('click',function(){
        	$('.cd-popup').removeClass('is-visible');
        })
        
        $('.cd-popup').addClass('is-visible');
        
        $('#confirm').on('click',function(){
        	that.callBackFun(callback);
        })
        
        $(document).keypress(function(e){
        	if(e.which == 13){
        		that.callBackFun(callback);
        	}
        });
	},
	//弹出框初始化函数
	//@Params type 弹出框类型
	init: function(type){
		if(!window.document.getElementById("alertConfirm")){
        	var link = document.createElement("link");
        	link.href = "static/css/alertConfirm.css";
        	link.rel = "stylesheet";
        	link.type = "text/css";
        	document.head.appendChild(link);
        	var alertC = window.document.createDocumentFragment();
        	var div = window.document.createElement("div");
        	div.id = "alertConfirm";
        	div.className = "cd-popup";
        	if(type == "single"){
        		div.innerHTML = "<div class='cd-popup-container'><p id='alertM'>确定要删除吗?</p><ul class='cd-buttons'><li class='single'><a id='confirm'>确定</a></li></ul><a class='cd-popup-close img-replace' id='close'>Close</a></div>"
        	}else if(type == "normal"){
        		div.innerHTML = "<div class='cd-popup-container'><p id='alertM'>确定要删除吗?</p><ul class='cd-buttons'><li><a id='confirm'>确定</a></li><li><a id='cancle'>取消</a></li></ul><a class='cd-popup-close img-replace' id='close'>Close</a></div>"	
        	}
        	alertC.appendChild(div);
        	window.document.getElementById("app").appendChild(alertC);
       }
	},
	//弹出框回调函数
	//@Params callback 弹出框回调函数
	callBackFun: function(callback){
		callback();
        $('#alertConfirm').remove();
	}
}

export default alertConfirm;


// WEBPACK FOOTER //
// ./static/js/alertConfirm.js